module.exports = __webpack_public_path__ + "img/editPage_wrap.2eaafd00.svg";